module.exports = __webpack_public_path__ + "img/rental_space.16d22182.jpg";